/* import __COLOCATED_TEMPLATE__ from './unanswered-questions.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();